import React, { useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/styles'

import { ReactComponent as BczmBase } from '../assets/maps/base.svg'
import { ReactComponent as Anexo3 } from '../assets/maps/anexo3.svg'
import { ReactComponent as Anexo5 } from '../assets/maps/anexo5.svg'
import { ReactComponent as CeresCurraisNovos } from '../assets/maps/ceres-cn.svg'


const useStyles = makeStyles(theme => ({
  map: {
    minHeight: 500,
  },
}));

const DefaultLocation = () => (
  <h4>Para localizar este material por favor informe o código acima a algum funcionário da biblioteca.</h4>
)

const LocationMap = ({location}) => {
  const classes = useStyles()
  const theme = useTheme()

  useEffect(() => {
    if(!location.shelfs)
      return
    
    location.shelfs.forEach(item => {
      const el = document.body.querySelector(`#p${item}`)
      if(el){
        el.setAttribute('fill', theme.palette.secondary.main)
      } 
    })
  }, [location])

  const librariesFloors = (library = 'default', floor = 'default') => {
    const libraries = {
      '661399': {
        'Anexo3': <Anexo3 className={classes.map} />,
        'Anexo5': <Anexo5 className={classes.map} />,
        'Base': <BczmBase className={classes.map} />,
        'default': <DefaultLocation />
      },
      '723664': {
        'Ceres-currais': <CeresCurraisNovos className={classes.map} />,
        'default': <DefaultLocation />
      },
      'default': {'default': <DefaultLocation />}
    }
    
    try {
      return libraries[library][floor]
    } catch {
      return <DefaultLocation />
    }
  }

  return librariesFloors(location.library, location.floor_name)
}

export default LocationMap